/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerProgramConfigurationDto } from '../models/EntityModelResponseContainerProgramConfigurationDto';
import type { EntityModelResponseContainerProgramDto } from '../models/EntityModelResponseContainerProgramDto';
import type { PagedModelEntityModelProgramDto } from '../models/PagedModelEntityModelProgramDto';
import type { PagedModelEntityModelProgramOperatorsDto } from '../models/PagedModelEntityModelProgramOperatorsDto';
import type { PagedResourcesAssemblerProgramDto } from '../models/PagedResourcesAssemblerProgramDto';
import type { PagedResourcesAssemblerProgramOperatorsDto } from '../models/PagedResourcesAssemblerProgramOperatorsDto';
import type { ProgramConfigurationDto } from '../models/ProgramConfigurationDto';
import type { ProgramDto } from '../models/ProgramDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemProgramControllerService {
    /**
     * @returns PagedModelEntityModelProgramDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        name,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerProgramDto,
        name?: string,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelProgramDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/programs',
            query: {
                'name': name,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: ProgramDto,
    }): CancelablePromise<EntityModelResponseContainerProgramDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/programs',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramConfigurationDto OK
     * @throws ApiError
     */
    public static readConfiguration({
        programId,
    }: {
        programId: number,
    }): CancelablePromise<EntityModelResponseContainerProgramConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/programs/configurations/{programId}',
            path: {
                'programId': programId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramConfigurationDto OK
     * @throws ApiError
     */
    public static updateConfiguration({
        programId,
        requestBody,
    }: {
        programId: number,
        requestBody: ProgramConfigurationDto,
    }): CancelablePromise<EntityModelResponseContainerProgramConfigurationDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/programs/configurations/{programId}',
            path: {
                'programId': programId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PagedModelEntityModelProgramOperatorsDto OK
     * @throws ApiError
     */
    public static listProgramOperators({
        assembler,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerProgramOperatorsDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelProgramOperatorsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/programs/operators',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        programId,
    }: {
        programId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/programs/{programId}',
            path: {
                'programId': programId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramDto OK
     * @throws ApiError
     */
    public static read({
        programId,
    }: {
        programId: number,
    }): CancelablePromise<EntityModelResponseContainerProgramDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/programs/{programId}',
            path: {
                'programId': programId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramDto OK
     * @throws ApiError
     */
    public static update({
        programId,
        requestBody,
    }: {
        programId: number,
        requestBody: ProgramDto,
    }): CancelablePromise<EntityModelResponseContainerProgramDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/programs/{programId}',
            path: {
                'programId': programId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
